/*global http*/
const tableFilter = {
	el: {
		filterSelect: document.querySelectorAll('.js-filter-table'),
		filterSelectContainer: document.querySelector('.table__selects'),
		tableHeading: document.querySelector('.js-table-heading'),
		tableContainer: document.querySelector('.js-table-content'),
		selectYears: document.querySelector('.js-years'),
		selectCourses: document.querySelector('.js-courses')
	},

	fxFilter(students, type) {
		const filteredResults = [...students].filter(el => el.type === type.value),
			msgNoResults = this.el.filterSelectContainer.dataset.msgNoResults,
			cellHeading = document.createElement('th')

		cellHeading.classList.add('table__cell', 'text-right', 'js-table-header')
		
		if (filteredResults.length === 0) {
			this.el.tableContainer.innerHTML +=
				`
					<tr class="table__row">
						<td class="table__cell"><span class="table__cell-copy">${msgNoResults}</span></td>
					</tr>
				`
		}

		else if (type.options[type.selectedIndex].dataset.extrafieldenabled === 'True') {
			cellHeading.textContent = type.options[type.selectedIndex].dataset.extrafieldheader
			this.el.tableHeading.appendChild(cellHeading)

			filteredResults.forEach(el => {
				this.el.tableContainer.innerHTML +=
					`
						<tr class="table__row">
							<td class="table__cell"><span class="table__cell-copy">${el.name}</span></td>
							<td class="table__cell text-right"><span class="table__cell-copy">${el.average}</span></td>
							<td class="table__cell text-right"><span class="table__cell-copy">${el.field}</span></td>
						</tr>
					`
			})
		}
		
		else {
			filteredResults.forEach(el => {
				this.el.tableContainer.innerHTML +=
					`
						<tr class="table__row">
							<td class="table__cell"><span class="table__cell-copy">${el.name}</span></td>
							<td class="table__cell text-right"><span class="table__cell-copy">${el.average}</span></td>
						</tr>
					`
			})
		}
	},

	events() {
		if (!this.el.filterSelectContainer) return

		const endpoint = this.el.filterSelectContainer.dataset.endpoint

		this.el.filterSelect.forEach(select => {
			select.addEventListener('change', e => {
				const callback = response => {
					const data = response.data

					this.el.tableContainer.innerHTML = ''
					document.querySelector('.js-table-header') ? this.el.tableHeading.removeChild(document.querySelector('.js-table-header')) : ''

					data.forEach(item => {
						if (select.classList.contains('js-years') && select.value === item.year)
							this.fxFilter(item.students, this.el.selectCourses)
						else if (item.year === this.el.selectYears.value)
							this.fxFilter(item.students, e.target)
					})
				}

				http.fxGet(endpoint, callback)

			})
		})
	},

	init() {
		this.events()
	}
}

tableFilter.init()